import { getTitle, getName, DATASETS } from '../Constants';
import { searchContext } from '../../context/Context';
import { useState } from 'react';
import SideBarContent from '../QueriedContent/SideBarContent';
import { useNavigate } from 'react-router-dom';

export default function RenderInfoLogic({ searchItems, selectedInfoItem, setSearchItems, isMapping }) {
  const { setSelectedInfoItem, view } = searchContext();
  const navigate = useNavigate();

  const foundTitles = Array.isArray(searchItems) ? searchItems.map(item => getTitle(item)) : [];
  const ids = Array.isArray(searchItems) ? searchItems.map(item => getName(item)) : [];
  const [showModalExample, setShowModalExample] = useState(false);

  const handleOpenModal = item => {
    setSelectedInfoItem(item);
    setTimeout(() => setShowModalExample(true), 0); // Use setTimeout(..., 0) to delay opening the modal until selectedInfoItem is updated.
  };

  const clear = index => {
    const updatedSearchItems = [...searchItems];
    updatedSearchItems.splice(index, 1);
    setSearchItems(updatedSearchItems);
    if (updatedSearchItems.length === 0) {
      navigate('/');
    }
  };
  const handleClearAndCloseInfoDiv = index => {
    clear(index);
  };

  return (
    <>
      {foundTitles.length > 0 && ids.length > 0 && (
        <div className="col-8 titCab">
          {foundTitles.length > 0 &&
            ids.length > 0 &&
            foundTitles.map((result, index) => (
              <div key={ids[index]}>
                <h4 className="titTabla d-flex">
                  {ids[index] && <span className="mr-2">{[result, ids[index]].join(', ')}</span>}
                  {result.title !== DATASETS.ALL && !isMapping && (
                    <div className="d-flex align-items-center">
                      <div className="mr-2">
                        <button
                          data-testid="open-info-button"
                          onClick={() => handleOpenModal(searchItems[index])}
                        >
                          <i className="bi-info-circle" />
                        </button>
                      </div>
                      <div>
                        <button
                          data-testid="close-info-button"
                          onClick={() => handleClearAndCloseInfoDiv(index)}
                        >
                          <i className="bi-x-circle"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </h4>
              </div>
            ))}
        </div>
      )}
      <div className="col-6 titTabla"></div>
      <SideBarContent
        selectedInfoItem={selectedInfoItem}
        view={view}
        showModalExample={showModalExample}
        setShowModalExample={setShowModalExample}
      />
    </>
  );
}
